import React, { Fragment, useCallback, useEffect, useState } from "react";
import { RiAddFill, RiBuilding2Fill } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { SelectComponent } from "screens/perfilAutonomo/components/SelectComponent";
import SelectAutocomplete from "components/selectAutoCompleteG";
import { TextInput } from "screens/perfilAutonomo/components/TextInput";
import { DefaultButton } from "screens/perfilAutonomo/components/defaultButton.component";
import {
  addButtonSx,
  removeButtonSx,
} from "screens/visitas/components/modalNova/utils";
import CurrencyFormat from "react-currency-format";
import { InputAdornment } from "@mui/material";
import {
  BooleanOptions,
  debounce,
  fName,
  fNO,
} from "screens/perfilAutonomo/utils";
import { BsTrash3Fill } from "react-icons/bs";
import { toast } from "react-toastify";
import { SecondaryButton } from "screens/perfilAutonomo/components/secondaryButton.component";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import CheckboxComponent from "components/CheckBoxG";
import * as S from "./style";
import {
  defaultRevendaUnidade,
  NumberOptions,
  revendaDataTemplate,
  RevendaUnidadeCadastrar,
  RevendaUnidadeEditar,
  StatusReserva,
} from "./utils";
import { fetchRevendaEmpreendimentosListar } from "../api/postRevendaEmpreendimentoListar";
import { fetchTipoRevendaListar } from "../api/postTipoRevendaListar";
import { postRevendaCaracteristicaListar } from "../api/postRevendaCaracteristicaListar";
import { fetchRevendaTipoVaga } from "../api/getRevendaTipoVaga";
import { fetchRevendaStatus } from "../api/getRevendaStatus";
import { postRevendaUnidade } from "../api/postRevendaUnidade";
import { HistoricoRevenda } from "./historicoRevenda.component";
import { putRevendaUnidade } from "../api/putRevendaUnidade";
import { PhoneInput } from "../../phoneInput.component";

const toNumber = (value: string | number): number | null => {
  if (typeof value === "number") return value;
  if (typeof value !== "string" || value.trim() === "") return null;

  return parseFloat(value.replace(/\./g, "").replace(",", "."));
};

export const NovaRevendaModal = ({
  open,
  onClose,
  refetch,
  edit,
  authToken,
}: {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  edit?: any;
  authToken: string;
}) => {
  const [data, setData] = useState(defaultRevendaUnidade);
  const [hasFilled, setHasFilled] = useState(false);
  const [saving, setSaving] = useState(false);

  const { data: empreendimentoOptions, isLoading: loadingEmpreendimentos } =
    fetchRevendaEmpreendimentosListar({ enabled: open, authToken });
  const { data: tipoRevendaOptions, isLoading: loadingTipoRevenda } =
    fetchTipoRevendaListar({ enabled: open, authToken });
  const [caracteristicaOptions, setCaracteristicaOptions] = useState<any>([]);
  const [loadingCaracteristica, setLoadingCaracteristica] = useState(false);
  const { data: tipoVagaOptions, isLoading: loadingTipoVaga } =
    fetchRevendaTipoVaga({ enabled: open, authToken });
  const { data: statusOptions, isLoading: loadingStatus } = fetchRevendaStatus({
    enabled: open,
    authToken,
  });

  const isLoading =
    loadingEmpreendimentos ||
    loadingTipoRevenda ||
    loadingCaracteristica ||
    loadingTipoVaga ||
    loadingStatus;

  useEffect(() => {
    if (edit && !isLoading && !hasFilled) handleFillEdit();
  }, [edit, isLoading]);

  const sumData = (key: "proprietarios" | "vagas", id?: number) => {
    if (data[key].length >= 10 && !id) return;

    setData((prev) => {
      if (id) {
        return {
          ...prev,
          [key]: (prev[key] as Array<{ id: number }>).filter(
            (item) => item.id !== id
          ),
        };
      }

      return { ...prev, [key]: [...prev[key], revendaDataTemplate[key]()] };
    });
  };

  const handleFillEdit = async () => {
    const _data = {
      idRevendaEmpreendimento: edit?.idRevendaEmpreendimento,
      idRevendaEmpreendimentoTorre: edit?.idRevendaEmpreendimentoTorre,
      idTipoRevenda: edit?.idTipoRevenda,
      idRevendaCaracteristica: edit?.idRevendaCaracteristica,
      andar: edit?.andar ?? "",
      unidade: edit?.unidade ?? "",
      pronto: edit?.pronto ?? null,
      proprietarios: edit?.proprietarios
        ? edit.proprietarios.map((item: any) => ({
            ...item,
            celular: fNO(item?.celular),
            id: Math.floor(Math.random() * 1e13),
          }))
        : defaultRevendaUnidade.proprietarios,
      chaves: edit?.chaves ?? null,
      habitado: edit?.habitado ?? null,
      deposito: edit?.deposito ?? null,
      numeroDormitorios: edit?.numeroDormitorios ?? null,
      numeroSuites: edit?.numeroSuites ?? null,
      churrasqueriaVaranda: edit?.churrasqueriaVaranda ?? null,
      mobiliado: edit?.mobiliado ?? null,
      vagas:
        edit?.vagas?.length > 0
          ? edit?.vagas?.map((item: any) => ({
              ...item,
              id: Math.floor(Math.random() * 1e13),
            }))
          : defaultRevendaUnidade.vagas,
      valorCondominio: edit?.valorCondominio ?? 0,
      valorIptu: edit?.valorIptu ?? 0,
      areaUtil: edit?.areaUtil ?? 0,
      valorUnidade: edit?.valorUnidade ?? 0,
      valorMetroQuadrado: edit?.valorMetroQuadrado ?? 0,
      saldoDevedor: edit?.saldoDevedor ?? 0,
      observacao: edit?.observacao ?? "",
      detalhamento: edit?.detalhamento ?? "",
      revendaStatus: edit?.revendaStatus ?? null,
      acompanhamento: "",
      nomeCliente: edit?.nomeCliente ?? "",
      rgCliente: edit?.rgCliente ?? "",
      usuarioResponsavel: edit?.usuarioResponsavel ?? "",
      vendidoSemNossaIntermediacao: edit?.vendidoSemNossaIntermediacao ?? false,
    };

    if (_data.idTipoRevenda) await handleCaracteristica(_data.idTipoRevenda);

    setData(_data);
    setHasFilled(true);
  };

  const handleM2 = useCallback(
    debounce(({ areaUtil, valorUnidade }) => {
      const area = toNumber(areaUtil);
      const valor = toNumber(valorUnidade);

      if (!area || !valor) {
        setData((prev) => ({ ...prev, valorMetroQuadrado: 0 }));
        return;
      }

      setData((prev) => ({
        ...prev,
        valorMetroQuadrado: Number((valor / area).toFixed(2)),
      }));
    }, 750),
    []
  );

  const handleCaracteristica = async (idTipoRevenda: string) => {
    if (idTipoRevenda === "") {
      setData((prev) => ({ ...prev, idRevendaCaracteristica: "" }));
      setCaracteristicaOptions([]);
      return;
    }
    setLoadingCaracteristica(true);

    try {
      const { success, data, notifications } =
        await postRevendaCaracteristicaListar(authToken, idTipoRevenda);
      if (!success) throw new Error(notifications?.[0]?.message);
      setCaracteristicaOptions(
        data?.response?.map((item: any) => ({
          label: item?.nome,
          value: item?.id,
        })) ?? []
      );
    } catch (error: any) {
      console.error(error);
      toast.error(
        error?.message
          ? `Erro: ${error.message}`
          : "Erro ao buscar caracteristicas"
      );
      setCaracteristicaOptions([]);
    } finally {
      setLoadingCaracteristica(false);
    }
  };

  const handleClose = () => {
    setTimeout(() => {
      setData(defaultRevendaUnidade);
      setHasFilled(false);
    }, 250);
    onClose();
  };

  const handleSubmit = () => {
    setSaving(true);

    const params = edit
      ? ({ authToken, id: edit?.id, ...data } as RevendaUnidadeEditar)
      : ({ authToken, ...data } as RevendaUnidadeCadastrar);
    const fn = edit ? putRevendaUnidade : postRevendaUnidade;

    fn(params as typeof fn extends (arg: infer P) => any ? P : never)
      .then(({ success, notifications }) => {
        if (success) {
          toast.success(
            `Unidade ${edit ? "editada" : "cadastrada"} com sucesso.`
          );
          handleClose();
          refetch();
        } else throw new Error(notifications?.[0]?.message ?? "");
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.message
            ? `Erro: ${error.message}`
            : `Erro ao ${edit ? "editar" : "cadastrar"} unidade`
        );
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const canSubmit = () => {
    const requiredStrings = [
      data.idRevendaEmpreendimento,
      data.idRevendaEmpreendimentoTorre,
      data.idTipoRevenda,
      data.idRevendaCaracteristica,
      data.andar,
      data.unidade,
    ];

    if (requiredStrings.some((val) => val === "")) return false;

    const requiredSelects = [data.pronto, data.revendaStatus];

    if (requiredSelects.some((val) => val === null)) return false;

    if (
      typeof data.numeroDormitorios !== "number" ||
      typeof data.numeroSuites !== "number"
    )
      return false;

    const requiredNumbers = [
      toNumber(data.areaUtil) ?? 0,
      toNumber(data.valorUnidade) ?? 0,
    ];

    if (requiredNumbers.some((val) => val < 1)) return false;

    const allOwnersValid = data.proprietarios.every(
      (item: any) => item.nome !== "" && item.celular !== ""
    );
    if (!allOwnersValid && !edit) return false;
    if (!allOwnersValid && !!edit?.podeVerDadosProprietario) return false;

    if (
      data.revendaStatus === StatusReserva.Reservado &&
      edit?.revendaStatus !== StatusReserva.Reservado
    ) {
      if (data.nomeCliente === "" || data.rgCliente === "") return false;
    }

    return true;
  };

  return (
    <S.DialogContainer open={open} onClose={handleClose} maxWidth="md">
      <S.Container>
        <S.IconContainer>
          <div className="icon-wrapper">
            <RiBuilding2Fill color="#333" />
          </div>

          <div className="title-container">
            <h1 className="title center">
              {edit ? "Editar" : "Cadastrar"} Unidade para Revenda
            </h1>
            {edit && (
              <h4 className="subtitle center">
                Responsável: {data.usuarioResponsavel ?? "--"}
              </h4>
            )}
          </div>

          <IoClose size={26} className="exit" onClick={handleClose} />
        </S.IconContainer>

        <S.Form>
          <S.Row>
            <S.Field>
              <p className="field-name">
                {"Empreendimento"}
                <span>{" *"}</span>
              </p>
              <SelectAutocomplete
                data={
                  empreendimentoOptions?.map((item: any) => ({
                    value: item?.id,
                    label: item?.nome,
                  })) ?? []
                }
                onChange={(val: { label: string; value: string }) => {
                  setData((prev) => ({
                    ...prev,
                    idRevendaEmpreendimento: val?.value ?? "",
                    idRevendaEmpreendimentoTorre: "",
                  }));
                }}
                value={
                  empreendimentoOptions
                    ?.map((item: any) => ({
                      value: item?.id,
                      label: item?.nome,
                    }))
                    ?.find(
                      (item: any) =>
                        item?.value === data.idRevendaEmpreendimento
                    ) ?? ""
                }
                disabled={
                  loadingEmpreendimentos || empreendimentoOptions?.length === 0
                }
              />
            </S.Field>
            <S.Row>
              <S.Field>
                <p className="field-name">
                  {"Torre"}
                  <span>{" *"}</span>
                </p>
                <SelectComponent
                  data={
                    data.idRevendaEmpreendimento
                      ? empreendimentoOptions
                          ?.find(
                            (item: any) =>
                              item?.id === data.idRevendaEmpreendimento
                          )
                          ?.revendaEmpreendimentoTorres?.map((item: any) => ({
                            value: item?.id,
                            label: item?.descricao,
                          }))
                      : []
                  }
                  onChange={(val: string) => {
                    setData((prev) => ({
                      ...prev,
                      idRevendaEmpreendimentoTorre: val ?? "",
                    }));
                  }}
                  value={data.idRevendaEmpreendimentoTorre}
                  disabled={!data.idRevendaEmpreendimento}
                  placeholder=""
                  renderLabel
                />
              </S.Field>
              <S.Field>
                <p className="field-name">
                  {"Tipo"}
                  <span>{" *"}</span>
                </p>
                <SelectComponent
                  data={
                    tipoRevendaOptions?.map((item: any) => ({
                      value: item?.id,
                      label: item?.nome,
                    })) ?? []
                  }
                  onChange={(val: string) => {
                    setData((prev) => ({
                      ...prev,
                      idTipoRevenda: val,
                      idRevendaCaracteristica: "",
                    }));
                    handleCaracteristica(val);
                  }}
                  value={data.idTipoRevenda}
                  disabled={
                    loadingTipoRevenda || tipoRevendaOptions?.length === 0
                  }
                  placeholder=""
                  renderLabel
                />
              </S.Field>
            </S.Row>
          </S.Row>

          <S.Row template="1fr 1fr 1fr 1fr">
            <S.Field>
              <p className="field-name">
                {"Característica"}
                <span>{" *"}</span>
              </p>
              <SelectComponent
                data={caracteristicaOptions}
                onChange={(val: string) => {
                  setData((prev) => ({
                    ...prev,
                    idRevendaCaracteristica: val ?? "",
                  }));
                }}
                value={data.idRevendaCaracteristica}
                disabled={
                  loadingCaracteristica ||
                  caracteristicaOptions?.length === 0 ||
                  !data.idTipoRevenda
                }
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">
                {"Andar"}
                <span>{"*"}</span>
              </p>
              <TextInput
                placeholder=""
                onChange={(val) => {
                  setData((prev) => ({
                    ...prev,
                    andar: val,
                  }));
                }}
                maxLength={10}
                value={data.andar}
              />
            </S.Field>
            <S.Field>
              <p className="field-name">
                {"Unidade "}
                <span>{"*"}</span>
              </p>
              <TextInput
                placeholder=""
                onChange={(val) => {
                  setData((prev) => ({
                    ...prev,
                    unidade: val,
                  }));
                }}
                maxLength={8}
                value={data.unidade}
              />
            </S.Field>
            <S.Field>
              <p className="field-name">
                {"Pronto"}
                <span>{" *"}</span>
              </p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    pronto: val,
                  }));
                }}
                value={data.pronto}
                placeholder=""
                renderLabel
              />
            </S.Field>
          </S.Row>

          {(edit === null || !!edit?.podeVerDadosProprietario) && (
            <>
              <S.Divider />

              <S.Row template="repeat(3, 1fr)">
                {data?.proprietarios?.map((item, index) => (
                  <Fragment key={item.id}>
                    <S.Field>
                      <p className="field-name">
                        {"Proprietário"}
                        <span>{" *"}</span>
                      </p>
                      <TextInput
                        placeholder=""
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            proprietarios: prev.proprietarios?.map((item, i) =>
                              i === index ? { ...item, nome: fName(val) } : item
                            ),
                          }));
                        }}
                        value={item.nome}
                      />
                    </S.Field>
                    <S.Field>
                      <p className="field-name">{"Email"}</p>
                      <TextInput
                        placeholder=""
                        onChange={(val) => {
                          setData((prev) => ({
                            ...prev,
                            proprietarios: prev.proprietarios?.map((item, i) =>
                              i === index ? { ...item, email: val } : item
                            ),
                          }));
                        }}
                        value={item.email}
                      />
                    </S.Field>
                    <div className="align-end" style={{ gap: 10 }}>
                      <S.Field>
                        <p className="field-name">
                          {"Celular"}
                          <span>{" *"}</span>
                        </p>
                        <PhoneInput
                          value={item.celular}
                          onChange={(val: string) => {
                            setData((prev) => ({
                              ...prev,
                              proprietarios: prev.proprietarios?.map(
                                (item, i) =>
                                  i === index
                                    ? { ...item, celular: fNO(val) }
                                    : item
                              ),
                            }));
                          }}
                        />
                      </S.Field>
                      {index === 0 ? (
                        <DefaultButton
                          onClick={() => sumData("proprietarios")}
                          style={{ ...addButtonSx, minWidth: 44 }}
                          content={<RiAddFill size={22} />}
                          disabled={data.proprietarios.length >= 10}
                        />
                      ) : (
                        <DefaultButton
                          onClick={() => sumData("proprietarios", item.id)}
                          style={{ ...removeButtonSx, minWidth: 44 }}
                          content={<BsTrash3Fill size={22} color={"#F43636"} />}
                        />
                      )}
                    </div>
                  </Fragment>
                ))}
              </S.Row>
            </>
          )}

          <S.Divider />

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p className="field-name">{"Chaves"}</p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    chaves: val,
                  }));
                }}
                value={data.chaves}
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Habitado"}</p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    habitado: val,
                  }));
                }}
                value={data.habitado}
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Depósito"}</p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    deposito: val,
                  }));
                }}
                value={data.deposito}
                placeholder=""
                renderLabel
              />
            </S.Field>
          </S.Row>

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p className="field-name">
                {"Número de dormitórios"}
                <span>{" *"}</span>
              </p>
              <SelectComponent
                data={NumberOptions}
                onChange={(val: number) => {
                  setData((prev) => ({
                    ...prev,
                    numeroDormitorios: val,
                  }));
                }}
                value={
                  typeof data.numeroDormitorios === "number"
                    ? data.numeroDormitorios
                    : ""
                }
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">
                {"Número de suítes"}
                <span>{" *"}</span>
              </p>
              <SelectComponent
                data={NumberOptions}
                onChange={(val: number) => {
                  setData((prev) => ({
                    ...prev,
                    numeroSuites: val,
                  }));
                }}
                value={
                  typeof data.numeroSuites === "number" ? data.numeroSuites : ""
                }
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Churrasqueira na varanda"}</p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    churrasqueriaVaranda: val,
                  }));
                }}
                value={data.churrasqueriaVaranda}
                placeholder=""
                renderLabel
              />
            </S.Field>
          </S.Row>

          <S.Row template="repeat(3, 1fr)">
            <S.Field>
              <p className="field-name">{"Mobiliado"}</p>
              <SelectComponent
                data={BooleanOptions}
                onChange={(val: boolean | null) => {
                  setData((prev) => ({
                    ...prev,
                    mobiliado: val,
                  }));
                }}
                value={data.mobiliado}
                placeholder=""
                renderLabel
              />
            </S.Field>
            {data?.vagas?.map((item, index) => (
              <div className="align-end" style={{ gap: 10 }} key={item.id}>
                <S.Field>
                  <p className="field-name">
                    {index === 0 ? "Adicionar vaga" : "Vaga"}
                  </p>
                  <SelectComponent
                    data={tipoVagaOptions ?? []}
                    onChange={(val: number) => {
                      setData((prev) => ({
                        ...prev,
                        vagas: prev.vagas?.map((i) => ({
                          ...i,
                          tipoVaga: i?.id === item?.id ? val : i?.tipoVaga,
                        })),
                      }));
                    }}
                    value={item.tipoVaga || ""}
                    clearIcon={index === 0}
                    disabled={
                      tipoVagaOptions?.length === 0 ||
                      !tipoVagaOptions ||
                      loadingTipoVaga
                    }
                    placeholder=""
                    renderLabel
                  />
                </S.Field>
                {index === 0 ? (
                  <DefaultButton
                    onClick={() => sumData("vagas")}
                    style={{ ...addButtonSx, minWidth: 44 }}
                    content={<RiAddFill size={22} />}
                    disabled={data.vagas.length >= 10}
                  />
                ) : (
                  <DefaultButton
                    onClick={() => sumData("vagas", item.id)}
                    style={{ ...removeButtonSx, minWidth: 44 }}
                    content={<BsTrash3Fill size={22} color={"#F43636"} />}
                  />
                )}
              </div>
            ))}
          </S.Row>

          <S.Divider />

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p className="field-name">{"Valor do condomínio"}</p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.valorCondominio}
                onValueChange={(values) => {
                  setData((prev) => ({
                    ...prev,
                    valorCondominio: values.formattedValue ?? "",
                  }));
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"R$"}</InputAdornment>
                  ),
                }}
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Valor do IPTU"}</p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.valorIptu}
                onValueChange={(values) => {
                  setData((prev) => ({
                    ...prev,
                    valorIptu: values.formattedValue ?? "",
                  }));
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"R$"}</InputAdornment>
                  ),
                }}
              />
            </S.Field>
            <S.Field>
              <p className="field-name">
                {"Área útil"}
                <span>{" *"}</span>
              </p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.areaUtil}
                onValueChange={(values) => {
                  setData((prev) => {
                    const _ = values.formattedValue ?? "";
                    handleM2({ ...data, areaUtil: _ });
                    return {
                      ...prev,
                      areaUtil: _,
                    };
                  });
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{"m2"}</InputAdornment>
                  ),
                }}
              />
            </S.Field>
          </S.Row>

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p className="field-name">
                {"Valor da unidade"}
                <span>{" *"}</span>
              </p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.valorUnidade}
                onValueChange={(values) => {
                  setData((prev) => {
                    const val = values.formattedValue ?? "";
                    handleM2({ ...data, valorUnidade: val });
                    return {
                      ...prev,
                      valorUnidade: val,
                    };
                  });
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"R$"}</InputAdornment>
                  ),
                }}
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Valor do m2"}</p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.valorMetroQuadrado}
                onValueChange={(values) => {
                  setData((prev) => ({
                    ...prev,
                    valorMetroQuadrado: values.floatValue
                      ? Number(values.floatValue)
                      : 0,
                  }));
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"R$"}</InputAdornment>
                  ),
                }}
                disabled
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Saldo devedor"}</p>
              <CurrencyFormat
                customInput={S.TextField}
                value={data.saldoDevedor}
                onValueChange={(values) => {
                  setData((prev) => ({
                    ...prev,
                    saldoDevedor: values.formattedValue ?? "",
                  }));
                }}
                variant="outlined"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"R$"}</InputAdornment>
                  ),
                }}
              />
            </S.Field>
          </S.Row>

          <S.Divider />

          <S.Row>
            <S.Field>
              <p className="field-name">{"Observação"}</p>
              <TextInput
                placeholder=""
                onChange={(val) => {
                  setData((prev) => ({ ...prev, observacao: val }));
                }}
                value={data.observacao}
                multiline
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Detalhamento"}</p>
              <TextInput
                placeholder=""
                onChange={(val) => {
                  setData((prev) => ({ ...prev, detalhamento: val }));
                }}
                value={data.detalhamento}
                multiline
              />
            </S.Field>
          </S.Row>

          <S.Row>
            <S.Field>
              <p className="field-name">
                {"Status da reserva"}
                <span>{" *"}</span>
              </p>
              <SelectComponent
                data={statusOptions ?? []}
                onChange={(val: number) => {
                  setData((prev) => ({
                    ...prev,
                    revendaStatus: val,
                  }));
                }}
                value={data.revendaStatus ?? ""}
                disabled={
                  !statusOptions || statusOptions?.length === 0 || loadingStatus
                }
                placeholder=""
                renderLabel
              />
            </S.Field>
            <S.Field>
              <p className="field-name">{"Acompanhamento"}</p>
              <TextInput
                placeholder=""
                onChange={(val) => {
                  setData((prev) => ({
                    ...prev,
                    acompanhamento: val,
                  }));
                }}
                value={data.acompanhamento}
              />
            </S.Field>
          </S.Row>

          {data.revendaStatus === StatusReserva.Vendido && (
            <div style={{ marginLeft: 8 }}>
              <CheckboxComponent
                checked={data.vendidoSemNossaIntermediacao}
                onChange={(e) => {
                  setData((prev) => ({
                    ...prev,
                    vendidoSemNossaIntermediacao: e?.target?.checked,
                  }));
                }}
                label="Vendido sem a nossa intermediação"
              />
            </div>
          )}

          {data.revendaStatus === StatusReserva.Reservado &&
            edit?.revendaStatus !== StatusReserva.Reservado && (
              <S.Row>
                <S.Field>
                  <p className="field-name">
                    {"Nome cliente"}
                    <span>{" *"}</span>
                  </p>
                  <TextInput
                    placeholder=""
                    onChange={(val) => {
                      setData((prev) => ({
                        ...prev,
                        nomeCliente: fName(val),
                      }));
                    }}
                    value={data.nomeCliente}
                  />
                </S.Field>
                <S.Field>
                  <p className="field-name">
                    {"RG cliente"}
                    <span>{" *"}</span>
                  </p>
                  <TextInput
                    placeholder=""
                    onChange={(val) => {
                      setData((prev) => ({
                        ...prev,
                        rgCliente: val,
                      }));
                    }}
                    value={data.rgCliente}
                    maxLength={50}
                  />
                </S.Field>
              </S.Row>
            )}

          {edit && (
            <>
              <S.Divider />
              <HistoricoRevenda
                data={edit?.acompanhamentos}
                podeVerDadosProprietario={edit?.podeVerDadosProprietario}
              />
            </>
          )}

          <div id="dummy" style={{ marginTop: 20 }} />
        </S.Form>

        <S.Row>
          <div id="dummy" />
          <S.Row>
            <SecondaryButton content={"Cancelar"} onClick={handleClose} />
            <PrimaryButton
              content={saving ? <Loading size={18} color="white" /> : "Salvar"}
              onClick={handleSubmit}
              disabled={saving || !canSubmit()}
            />
          </S.Row>
        </S.Row>
      </S.Container>
    </S.DialogContainer>
  );
};
